<div>
  <div class="tooltip-container">
    <ng-template #simpleText>
      {{ text }}
    </ng-template>
    <ng-container *ngTemplateOutlet="contentTemplate || simpleText"> </ng-container>
  </div>
</div>
